module.exports = __webpack_public_path__ + "static/media/header-recruitment.73c69804.png";